// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formik-filter-text-field {
  position: relative;
}

.formik-filter-text-field__tooltip {
  color: #fff;
  background: #000000b3;
  border-radius: 3px;
  height: 25px;
  display: none;
  position: absolute;
  top: -25px;
  left: 0;
}

.formik-filter-text-field__tooltip .fa {
  color: #fc0;
}

.formik-filter-text-field__tooltip--visible {
  align-items: center;
  display: flex;
}

.formik-filter-text-field__comparator {
  margin-right: 10px;
}

.formik-filter-text-field__comparator:last-of-type {
  margin-right: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormikFilterTextField/styles.css","webpack://./services/frontend/app/components/FormikFilterTextField/styles.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".formik-filter-text-field {\n  position: relative;\n}\n\n.formik-filter-text-field__tooltip {\n  display: none;\n  position: absolute;\n  top: -25px;\n  left: 0;\n  height: 25px;\n  background: rgba(0, 0, 0, 0.7);\n  color: #ffffff;\n  border-radius: 3px;\n}\n\n.formik-filter-text-field__tooltip .fa {\n    color: #ffcc00;\n  }\n\n.formik-filter-text-field__tooltip--visible {\n  display: flex;\n  align-items: center;\n}\n\n.formik-filter-text-field__comparator {\n  margin-right: 10px;\n}\n\n.formik-filter-text-field__comparator:last-of-type {\n    margin-right: 0;\n  }\n",".formik-filter-text-field {\n  position: relative;\n}\n\n.formik-filter-text-field__tooltip {\n  color: #fff;\n  background: #000000b3;\n  border-radius: 3px;\n  height: 25px;\n  display: none;\n  position: absolute;\n  top: -25px;\n  left: 0;\n}\n\n.formik-filter-text-field__tooltip .fa {\n  color: #fc0;\n}\n\n.formik-filter-text-field__tooltip--visible {\n  align-items: center;\n  display: flex;\n}\n\n.formik-filter-text-field__comparator {\n  margin-right: 10px;\n}\n\n.formik-filter-text-field__comparator:last-of-type {\n  margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
